<p-panel>
  <div class="d-flex align-content-center"
       [ngClass]="{ 'justify-content-between': env.activateREA, 'justify-content-left': !env.activateREA }">

    <div>
      @if (flag === 'edit') {
        <h4>{{ headerTitleWhenEdit }}</h4>
      } @else {
        <h4>{{ headerTitleWhenNew }}</h4>
      }
    </div>

    <div>
      @if (env.activateREA) {
        <button
          class="btn bg-primary text-white bg-gradient text-black rea-btn mx-4 border-0"
          id="export-rea"
          (click)="showDialogExportREA = true"
          [disabled]="isReaDisabled">
          <i class="fa fa-download"></i>
          Importar REA
        </button>
      }
    </div>
  </div>

  <div class="row">
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [previousData]="getModel()"
      [request]="getType() === FormRequestTypes.EDIT ? fincasApi.fincasPUT : fincasApi.fincasPOST"
      [getRequest]="fincasApi.fincasGET">
    </app-reactive-form-builder>
  </div>
</p-panel>

<p-dialog
  [(visible)]="showDialogExportREA"
  header="Importar REA"
  styleClass="rea-dialog"
  [breakpoints]="REA_DIALOG_BREAKPOINTS"
  [modal]="true"
  [closable]="false"
  id="export-rea-dialog">

  <ng-template pTemplate="body">
    <div class="p-fluid">
      <div class="p-field p-col-12 p-md-6">
        <label for="input-text">Código REA</label> : {{ form.model.codigo_REA }}
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="input-text">NIF</label> : {{ form.model.nif }}
      </div>
    </div>

    <div>
      @if (historicoREA?.statusCode === HTTP.Created) {
        <p-message class="mx-5" severity="info"> Nueva importación</p-message>
      }

      @if (historicoREA?.statusCode === HTTP.Ok) {
        <p-message class="mx-5" severity="info"> Última importación: {{ historicoREA?.data?.fecha }} </p-message>
      }

    </div>

    <div class="d-flex justify-content-center align-content-center mx-5">
      @if (showSpinner) {
        <p-progress-spinner
          styleClass="p-component-overlay m-auto"
          [strokeWidth]="REA_SPINNER_STROKE"
          [animationDuration]="REA_SPINNER_DURATION">
        </p-progress-spinner>
      }

      @if (importResult?.statusCode === HTTP.Accepted) {
        <div class="w-100">
          <p-card>
            <h4>Detalle de importación</h4>
            <hr>
            <p>Parcelas no insertadas: <b>{{ importResult?.data?.parcelasNoInsertadas }}</b></p>
            <p>Parcelas insertadas: <b>{{ importResult?.data?.parcelasInsertadas }}</b></p>
            <p>Parcelas no actualizadas: <b>{{ importResult?.data?.parcelasNoActualizadas }}</b></p>
            <p>Parcelas actualizadas: <b>{{ importResult?.data?.parcelasActualizadas }}</b></p>
          </p-card>
        </div>
      }
    </div>

    @switch (messageState) {
    
        @case ('warning') {
          <p-message class="mx-5" severity="warn"> Falta datos para exportar REA </p-message>
        }

        @case ('error') {
          <p-message class="mx-5" severity="error">{{ importResult?.statusMessage }}</p-message>
        }

        @case ('success') {
          <p-message class="mx-5" severity="success">
            {{ importResult?.statusMessage }}
          </p-message>
        }
    }
  </ng-template>

  <ng-template #footer>
    <div class="d-flex justify-content-center align-content-center gap-5 w-100">
      
      @if (importResult?.statusCode) {
        <button class="btn btn-dark mx-2" (click)="resetReaDialog()">Volver</button>
      } @else {
        <button class="btn btn-dark bg-gradient" (click)="resetReaDialog()">Cancelar</button>
      }

      @if (showBtnConfirm) {
        <button class="btn btn-success bg-gradient" (click)="onExportREA()">Continuar</button>
      }
    </div>
  </ng-template>
</p-dialog>
